__turbopack_context__.v({
  "className": "xsvO6a_className",
  "variable": "xsvO6a_variable",
});
